import { render, staticRenderFns } from "./PKCChecklistsTable.vue?vue&type=template&id=7185a554"
import script from "./PKCChecklistsTable.vue?vue&type=script&lang=js"
export * from "./PKCChecklistsTable.vue?vue&type=script&lang=js"
import style0 from "./PKCChecklistsTable.vue?vue&type=style&index=0&id=7185a554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports